"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on 11/02/2019
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * FavouriteConverter
 *
 * @author JMr
 */


var FavouriteConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(FavouriteConverter, _DataObjectConverter_);

  function FavouriteConverter() {
    _classCallCheck(this, FavouriteConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(FavouriteConverter).apply(this, arguments));
  }

  return FavouriteConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.FavouriteConverter = FavouriteConverter;